/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Features_Color_TitleInputs */

const en_fc_home_features_color_title = /** @type {(inputs: Fc_Home_Features_Color_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color grading with scopes`)
};

/**
* | output |
* | --- |
* | "Color grading with scopes" |
*
* @param {Fc_Home_Features_Color_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_features_color_title = /** @type {((inputs?: Fc_Home_Features_Color_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Features_Color_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_features_color_title(inputs)
});
export { fc_home_features_color_title as "fc.home.features.color.title" }